import * as React from "react"
import * as moment from "moment"
import * as _ from "lodash";
import { IMetricData } from "@curefit/metrics-common";
import { Goal } from "@curefit/gmf-common";
import ILifestyleGoal from "../../models/ILifestyleGoal";
import {default as CustomHeader, ICustomHeaderInfo} from "../utils/CustomHeader";
import IMetric from "../../models/metrics/IMetric";
import TextInput from "../TextInput";
import AppUtils from "../../utils/AppUtils";
import GoalChartComponent from "../GoalChartComponent";

/**
 * Created by aditya on 16/07/18.
 */

let GoalItemEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "metric", display: "METRIC", mandatory: true},
    {label: "ideal", display: "TARGET"},
    {label: "min", display: "TARGET MIN"},
    {label: "max", display: "TARGET MAX"},
    {label: "current", display: "INITIAL"}
];

let GoalItemEditorMonthsHeaderInfos: ICustomHeaderInfo[] = [
    {label: "months-label", display: "MONTHS"},
    {label: "month-header", display: "01"},
    {label: "month-header", display: "02"},
    {label: "month-header", display: "03"},
    {label: "month-header", display: "04"},
    {label: "month-header", display: "05"},
    {label: "month-header", display: "06"},
    {label: "month-header", display: "07"},
    {label: "month-header", display: "08"},
    {label: "month-header", display: "09"},
    {label: "month-header", display: "10"},
    {label: "month-header", display: "11"},
    {label: "month-header", display: "12"}
];

export interface HealthTargetItemViewProps {
    goalsType?: string;
    consultationType?: string,
    item: ILifestyleGoal;
    onDataChange: (update: any) => any,
    staticMetrics: IMetric[],
    startDate: string,
    staticGoals: {[key: string]: Goal},
    patientMetrics: {[metricId: string]: IMetricData[]}
}

class HealthTargetItemView extends React.Component<HealthTargetItemViewProps> {
    constructor(props: HealthTargetItemViewProps) {
        super(props);
    }

    onCurrentTargetChange = (evt: any) => {
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(parseInt(evt.target.value)) || evt.target.value === "") {
                let value = !isNaN(parseInt(evt.target.value)) ? parseInt(evt.target.value) : "";
                let idealValue = { ...this.props.item.idealValue, value };
                let currentItem = { ...this.props.item, idealValue };
                this.props.onDataChange(currentItem);
            }
        } else {
            let value = evt.target.value;
            let idealValue = { ...this.props.item.idealValue, value };
            let currentItem = { ...this.props.item, idealValue };
            this.props.onDataChange(currentItem);
        }
    }

    getMetricNameFromId = (id: string) => {
        let metricName = "";
        _.map(Object.values(this.props.staticMetrics), (item: IMetric) => {
            if (item.id === id) {
                metricName = item.name;
                return false;
            }
        })
        return metricName;
    }

    updateMetric = (value: string) => {
        let currentItem = { ...this.props.item, metricId: value, metricName: this.getMetricNameFromId(value) };
        this.props.onDataChange(currentItem)
    }

    onMinValueChange = (evt: any) => {
        let value = evt.target.value;
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(parseInt(value)) || value === "") {
                value = !isNaN(parseInt(evt.target.value)) ? parseInt(evt.target.value) : "";
                let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, min: value } };
                let currentItem = { ...this.props.item, idealValue };
                this.props.onDataChange(currentItem);
            }
        } else {
            let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, min: value } };
            let currentItem = { ...this.props.item, idealValue };
            this.props.onDataChange(currentItem);
        }
    }

    onMaxValueChange = (evt: any) => {
        let value = evt.target.value;
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(parseInt(value)) || value === "") {
                value = !isNaN(parseInt(evt.target.value)) ? parseInt(evt.target.value) : "";
                let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, max: value } };
                let currentItem = { ...this.props.item, idealValue };
                this.props.onDataChange(currentItem);
            }
        } else {
            let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, max: value } };
            let currentItem = { ...this.props.item, idealValue };
            this.props.onDataChange(currentItem);
        }
    }

    onMetricValueChange = (evt: any, index: number) => {
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(evt.target.value) && !isNaN(parseInt(evt.target.value)) || evt.target.value === "") {
                let value = !isNaN(parseInt(evt.target.value)) ? parseInt(evt.target.value) : "" as any;
                let {startDate} = this.props;
                let requiredDate = moment(startDate).add(index, "M").valueOf() as any;
                let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
                if (targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate) !== -1) {
                    let requiredIndex = targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate);
                    targets[requiredIndex].value = value;
                    // targets[requiredIndex].displayValue = evt.target.value;
                    this.props.onDataChange({ ...this.props.item, targets: targets })
                } else {
                    let metricValue = { targetEpoch: requiredDate, value }
                    targets.push(metricValue);
                    this.props.onDataChange({ ...this.props.item, targets: targets })
                }
            }
        } else {
            let value = evt.target.value;
            let {startDate} = this.props;
            let requiredDate = moment(startDate).add(index, "M").format("YYYY-MM-DD");
            let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
            if (targets.map(item => moment(item.targetEpoch).format("YYYY-MM-DD")).indexOf(requiredDate) !== -1) {
                let requiredIndex = targets.map(item => moment(item.targetEpoch).format("YYYY-MM-DD")).indexOf(requiredDate);
                targets[requiredIndex].value = value;
                this.props.onDataChange({ ...this.props.item, targets: targets })
            } else {
                let metricValue = { targetEpoch: requiredDate, value }
                targets.push(metricValue);
                this.props.onDataChange({ ...this.props.item, targets: targets })
            }
        }
    }

    onMetricValueBlur = (evt: any, index: number) => {
        /*let value = !isNaN(parseInt(evt.target.value)) ? parseInt(evt.target.value) : "";
        let {startDate} = this.props;
        let requiredDate = moment(startDate).add(index, "M").format("YYYY-MM-DD");
        let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
        if (targets.map(item => moment(item.targetEpoch).format("YYYY-MM-DD")).indexOf(requiredDate) !== -1) {
            let requiredIndex = targets.map(item => moment(item.targetEpoch).format("YYYY-MM-DD")).indexOf(requiredDate);
            targets[requiredIndex].value = value;
            delete targets[requiredIndex].displayValue;
            this.props.onDataChange({ ...this.props.item, targets: targets })
        } else {
            let metricValue = { targetEpoch: requiredDate, value }
            targets.push(metricValue);
            this.props.onDataChange({ ...this.props.item, targets: targets })
        }*/
    }

    getMetricValue = (index: number) => {
        let {startDate} = this.props;
        let requiredDate = moment(startDate).add(index, "M").valueOf();
        let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
        if (targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate) !== -1) {
            let requiredIndex = targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate);
            return targets[requiredIndex].displayValue !== undefined ? targets[requiredIndex].displayValue : targets[requiredIndex].value;
        } else {
            return "";
        }
    }

    getMetricDate = (index: number) => {
        let {startDate} = this.props;
        let requiredDate = moment(startDate).add(index, "M").valueOf();
        let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
        if (targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate) !== -1) {
            let requiredIndex = targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate);
            return targets[requiredIndex].targetEpoch;
        } else {
            return "";
        }
    }

    generateChartRows = () => {
        let rowArray: any = [];
        if (AppUtils.isDefined(this.props.patientMetrics) && AppUtils.isDefined(this.props.patientMetrics[this.props.item.metricId])) {
            this.props.patientMetrics[this.props.item.metricId].forEach((metric: IMetricData, index: number) => {
                let date = new Date(metric.metricDate);
                let fullDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
                let item = [];
                // console.log("__DATE__", date.getMonth() + 1, date.getDate(), date.getFullYear());
                item.push(date.getMonth() + 1);
                item.push(metric.value);
                let hoverItem = `<div style="padding: 5px; min-width: 60px"><div style="font-size: 14px; font-weight: bold">${metric.value}</div><div style="font-size: 8px">${fullDate}</div></div>`;
                item.push(hoverItem);
                rowArray.push(item as any);
            })
        }
        return rowArray;
    }

    /* generateGoalMerticItems = () => {
        let goalItems: IStaticDataValue[] = [];
        _.map(this.props.staticMetrics, (metric: IMetric) => {
            goalItems.push({ internalValue: metric.id, displayValue: metric.name });
        })
        return goalItems;
    } */

    getMetricNameFromMetricId = (metricId: string) => {
        let metrics = Object.values(this.props.staticMetrics);
        let metricIds = metrics.map(item => item.id);
        let index = metricIds.indexOf(metricId);
        if (index !== -1) return metrics[index].name;
        else return "";
    }

    onGoalMetricNameChange = (evt: any) => {
        let currentItem = { ...this.props.item, metricId: evt.target.value };
        this.props.onDataChange(currentItem)
    }

    _getRecordedValue = (monthIndex: number): string | number => {
        let value = null;
        if (AppUtils.isDefined(this.props.patientMetrics) && !_.isEmpty(this.props.patientMetrics[this.props.item.metricId])) {
            const currentMetric: IMetricData[] = this.props.patientMetrics[this.props.item.metricId];
            const requiredEndDateEpoch = AppUtils.getRequiredGoalMilestoneDayEpoch(Number(this.props.startDate), monthIndex, "END");
            const requiredStartDateEpoch = AppUtils.getRequiredGoalMilestoneDayEpoch(Number(this.props.startDate), monthIndex - 1, "START");
            const requiredMetricEpochs = currentMetric.filter((metricItem: IMetricData) => metricItem.metricDate >= requiredStartDateEpoch && metricItem.metricDate <= requiredEndDateEpoch);
            const latestRecordedValueEpoch = !_.isEmpty(requiredMetricEpochs) ? Math.max.apply(null, requiredMetricEpochs.map(item => item.metricDate)) : null;
            if (AppUtils.isDefined(latestRecordedValueEpoch)) {
                value = requiredMetricEpochs.find(item => item.metricDate === latestRecordedValueEpoch).value;
            }
        }
        return value;
    };

    generateMonthsHeader = (): ICustomHeaderInfo[] => {
        let monthsHeader: ICustomHeaderInfo[] = [];
        monthsHeader.push({
            label: "months-label",
            display: "MONTHS"
        })
        _.times(12, (index: number) => {
            monthsHeader.push({
                label: "month-header",
                display: `M${index + 1}`
            })
        });
        return monthsHeader;
    }

    generateMonthsSubHeader = (): ICustomHeaderInfo[] => {
        let monthsHeader: ICustomHeaderInfo[] = [];
        monthsHeader.push({
            label: "months-label",
            display: "starts on"
        })
        _.times(12, (index: number) => {
            let {startDate} = this.props;
            monthsHeader.push({
                label: "month-header",
                display: moment(startDate).add(index + 1, "M").format("D-MMM")
            })
        });
        return monthsHeader;
    }

    render() {
        let idealValue = !_.isEmpty(this.props.item.idealValue) && !_.isNull(this.props.item.idealValue.value) ? this.props.item.idealValue.value : "";
        let currentValue = !_.isEmpty(this.props.item.currentValue) && !_.isNull(this.props.item.currentValue.value) ? this.props.item.currentValue.value : "";
        let selectedMetric = this.props.item.metricId !== undefined && this.props.item.metricId !== null ? this.getMetricNameFromMetricId(this.props.item.metricId) : null;
        let minValue =  AppUtils.isDefined(this.props.item.idealValue) && AppUtils.isDefined(this.props.item.idealValue.range) ? this.props.item.idealValue.range.min : "";
        let maxValue =  AppUtils.isDefined(this.props.item.idealValue) && AppUtils.isDefined(this.props.item.idealValue.range) ? this.props.item.idealValue.range.max : "";
        return (
            <div className="health-target-item-editor health-target-item-view" >
                <div className={"metric-container"}>
                    {
                        this.props.goalsType === "PRIMARY" &&
                        <div className={"goal-chart-container"}>
                            <GoalChartComponent currentValue={""} averageValue={""}
                                                rows={this.generateChartRows()} chartName={`metric-chart-${new Date().getTime()}`}
                                                rootClass={"patient-health-targets-chart"} subClass={"metric"}
                                                title={""} key={`chart-component`} width={250}/>
                        </div>
                    }
                </div>
                {
                    this.props.goalsType === "PRIMARY" &&
                    <CustomHeader headerInfos={GoalItemEditorHeaderInfos} rootCls={"patient-goal"}/>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={"health-target-item-editor-metric"}>
                        <span>{selectedMetric}</span>
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={"health-target-item-editor-ideal"}>
                        <span>{idealValue}</span>
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={"health-target-item-editor-min"}>
                        <span>{minValue}</span>
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={"health-target-item-editor-max"}>
                        <span>{maxValue}</span>
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={"health-target-item-editor-current"}>
                        <span>{currentValue}</span>
                    </div>
                }
                <CustomHeader headerInfos={this.generateMonthsHeader()} rootCls={"patient-goal-months-header"}/>
                <CustomHeader headerInfos={this.generateMonthsSubHeader()} rootCls={"patient-goal-months-sub-header"}/>
                <div className={"month-target-input-container label-container"}>
                    <div>MILESTONES</div>
                    <div>RECORDED</div>
                </div>
                {
                    _.times(12, (index: number) => {
                        return <div className={"month-target-input-container"} key={`health-target-month-input-container-${index}`}>
                            <div>
                                <TextInput disabled={true} name={`doctor-target-input-${index + 1}`} onChange={(evt) => this.onMetricValueChange(evt, index + 1)} value={this.getMetricValue(index + 1)}/>
                            </div>
                            <div>
                                <TextInput name={`patient-target-input-${index + 1}`} disabled={true} value={this._getRecordedValue(index + 1)}/>
                            </div>
                        </div>
                    })
                }
                {/*{*/}
                    {/*this.props.goalsType === "PRIMARY" && !_.isNull(formattedStartDate) &&*/}
                    {/*<div className={"milstones-start-date-info-container"}>{`The milestones start from ${formattedStartDate}`}</div>*/}
                {/*}*/}
            </div>
        )
    }
}

export default HealthTargetItemView;